import React, { useState } from "react";
import axios from "axios";
import "./Enquirypoup.css";




const EnquiryModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // API Submit
const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    await axios.post(
      "https://knsonline.in/uat/RestAPI_V1/cp/v1/sendEmailToCustomer",
      JSON.stringify({
        name: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
      }),
      {
        headers: {
       Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded"
        },
      }
    );

    alert("Enquiry Sent Successfully ✅");

    setFormData({
      fullName: "",
      phone: "",
      email: "",
      message: "",
    });

    onClose();

  } catch (error) {
    console.error(error.response || error);
    alert("Something went wrong ❌");
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="modal-overlay">
      <div className="modal-box">

        <button className="close-btn" onClick={onClose}>
          ✖
        </button>

        <h2 className="modal-title">Quick Enquiry</h2>

        <form className="jll-form" onSubmit={handleSubmit}>
          <div className="row">
            <div className="field">
              <label>Full Name *</label>
              <input
                type="text"
                name="fullName"
                placeholder="Enter your full name"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="field">
              <label>Mobile Phone *</label>
              <input
                type="tel"
                name="phone"
                placeholder="Enter your mobile number"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="field">
            <label>Email Address *</label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email address"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="field">
            <label>Message</label>
            <textarea
              rows="3"
              name="message"
              placeholder="Enter your message"
              value={formData.message}
              onChange={handleChange}
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Submit Enquiry"}
          </button>
        </form>

      </div>
    </div>
  );
};

export default EnquiryModal;
